import { useIsFetching, useIsMutating } from "@tanstack/react-query";
import { cn } from "@/lib/utils";

// Barra fina indeterminada no topo da tela. Visível enquanto qualquer query
// estiver buscando dados ou qualquer mutation estiver em andamento.
// Útil principalmente durante cold starts de lambda, onde a primeira
// chamada pode demorar segundos.
export function GlobalLoadingBar() {
  const fetching = useIsFetching();
  const mutating = useIsMutating();
  const active = fetching > 0 || mutating > 0;

  return (
    <div
      className={cn(
        "pointer-events-none fixed left-0 right-0 top-0 z-50 h-0.5 overflow-hidden bg-primary/20 transition-opacity duration-200",
        active ? "opacity-100" : "opacity-0",
      )}
      role="progressbar"
      aria-hidden={!active}
    >
      <div className="h-full w-1/3 origin-left animate-loading-bar bg-primary" />
    </div>
  );
}
